<template>
  <div>
    <b-navbar
      class="footer-bar"
    >
      <b-navbar-nav>
        <b-button
          :disabled="isView[0]"
          class="defaultButton"
          :class="{ selected: isCurrentView('compagny') }"
          @click="changeView('compagny')"
        >
          <img src="icons/entreprise.png" alt />{{
            $t("components.pageFooter.btnCompagny")
          }}
        </b-button>

        <b-button
          :disabled="isView[1]"
          class="defaultButton"
          :class="{ selected: isCurrentView('themesList') }"
          @click="changeView('themesList')"
        >
          <img src="icons/themes.png" alt />{{
            $t("components.pageFooter.btnThemes")
          }}
        </b-button>

        <select
          v-if="view !== 'compagny'"
          class="themeSelector"
          ref="themeSelector"
          v-model="selectTheme"
          v-on:change="changeThemeView()"
        >
          <option :value="null" hidden>{{
            $t("components.pageFooter.dropdown")
          }}</option>
          <optgroup label="Thèmes proposés">
            <option
              v-for="theme in proposedThemes"
              :key="theme.ref"
              :value="theme"
              >{{ theme.title }}</option
            >
          </optgroup>
          <optgroup v-if="customThemes.length > 0" label="Thèmes personnalisés">
            <option
              v-for="theme in customThemes"
              :key="theme.ref"
              :value="theme"
              >{{ theme.title }}</option
            >
          </optgroup>
        </select>
        <div v-else class="no-dropdown"></div>

        <b-button
          :disabled="isCurrentView('synthesis') || !synthesisAccessible"
          class="defaultButton"
          :class="{ selected: isCurrentView('synthesis') }"
          @click="changeView('synthesis')"
        >
          <img src="icons/synthese.png" alt />{{
            $t("components.pageFooter.btnSynthesis")
          }}
        </b-button>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: "PageFooter",
  props: {
    view: String,
    activeTheme: Object
  },
  computed: {
    // analyser quel est le bouton actif afin de lui appliquer le style approprié
    isView: function() {
      if (this.view == "compagny") return [true, false, false];
      if (this.view == "themesList") return [false, true, false];
      if (this.view == "synthesis") return [false, false, true];
      if (this.view == "theme") return [false, false, false];
      else return null;
    },

    // récupérer les thèmes perso
    customThemes: function() {
      var themes = this.$store.state.gpsstModule.gpsst.themes;
      var themeList = [];
      for (let i = 0; i < themes.length; i++) {
        if (themes[i].custom) themeList.push(themes[i]);
      }
      themeList.sort(this.alphaSort);
      return themeList;
    },

    // récupérer les thèmes par défaut
    proposedThemes: function() {
      var themes = this.$store.state.gpsstModule.gpsst.themes;
      var themeList = [];
      for (let i = 0; i < themes.length; i++) {
        if (!themes[i].custom) {
          themeList.push(themes[i]);
        }
      }
      themeList.sort(this.alphaSort);
      return themeList;
    },

    themes: function() {
      return this.$store.state.gpsstModule.gpsst.themes;
    },

    synthesisAccessible: function() {
      // on regarde si l'accès à la synthèse est possible
      if (this.$store.state.appState.compagnyCompleted) {
        for (let i = 0; i < this.themes.length; i++) {
          if (
            this.themes[i].status == "complete" ||
            this.themes[i].status == "incomplete"
          ) {
            return true;
          }
        }
      }
      return false;
    }
  },
  watch: {
    view: function() {
      // quand on n'est plus sur une page theme, on remet la valeur du select à sa valeur par défault
      if (this.view !== "theme") {
        this.selectTheme = null;
      } else {
        this.selectTheme = this.activeTheme;
      }
    }
  },
  data: function() {
    return {
      selectTheme: null,
    };
  },
  methods: {
    /**
     * Indique si la vue de nom donné est la vue actuellement affichée.
     * @param {string} viewName - Nom de la vue
     * @returns {boolean} true s'il s'agit de la vue actuellement affichée.
     */
    isCurrentView(viewName) {
      return this.view == viewName;
    },

    alphaSort: function(a, b) {
      if (a.title < b.title) return -1;
      if (a.title > b.title) return 1;
      return 0;
    },

    /**
     * Affiche la vue "theme" pour le thème sélectionné, ou à défaut la vue "themesList" si pas de thème sélectionné.
     */
    changeThemeView() {
      this.$refs.themeSelector.blur();

      if (this.selectTheme) {
        this.$emit("changeview", {
          view: "theme",
          theme: this.selectTheme
        });
      } else {
        this.$emit("changeview", { view: "themesList" });
      }
    },

    /**
     * Affiche la vue de nom donné.
     *
     * @param {string} viewName - Nom de la vue
     */
    changeView: function(viewName) {
      // TODO? reproduire l'action de validation du formulaire Compagnycontext depuis le bouton 'Thèmes'

      // Si on est sur la vue "compagny", on procède différemment
      if (this.view == "compagny") {
        this.$store.commit("SET_NEXT_VIEW_AFTER_COMPAGNY", viewName);
        this.$store.commit("SET_TRY_VALIDATE_COMPAGNY", true);
      } else {
        this.$emit("changeview", { view: viewName });
      }
    }
  }
};
</script>

<style lang="sass" scoped>
@import "../sass/_variables.sass"
@import "../sass/_media.sass"

.navbar
  background-color: $lightgray-3
  padding: 0
  
  .navbar-nav
    justify-content: space-between
    align-items: center
    margin: 0 auto
    padding: 0.5rem 1rem
    min-height: 5em
    max-width: 920px
    width: 100%
    @media (max-width: 500px) 
      display: flex
      flex-wrap: wrap
      flex-direction: row

    @include ieOnly
      height: 5em

  .defaultButton
    flex-shrink: 1
    align-self: center
    margin-right: 20px
    white-space: nowrap
    font-family: 'brother-1816', sans-serif
    font-weight: 700
    font-size: 1.38em
    color: #161616
    height: 4.23rem
    border: 1px solid #161616
    border-radius: 52px
    background: transparent
    padding: 0 1.5rem

    &:last-of-type
      margin-right: 0

    img
      filter: brightness(0)
      transition: none

    &:hover, &:focus, &:active, &.selected, &.active
      background: transparent !important
      color: #161616 !important
      border-color: #161616 !important
      box-shadow: none !important
      opacity: 1 !important
      text-decoration: none !important

      img
        filter: brightness(0)

    @media (max-width: 500px)
      width: 100%
      margin-right: 0
      margin-bottom: 10px
      padding: 0 10px
      display: flex
      justify-content: center
      align-items: center

  /* TODO? à généraliser pour tous les select dans App.vue ? */
  .themeSelector
    flex-shrink: 10
    align-self: center
    padding-right: 2em
    cursor: pointer
    max-width: 400px
    margin-right: 20px
    line-height: 2.1em
    min-height: 2.25em
    padding:0 30px 0 10px
    font-size: 1em
    width: 100%
    border:1px solid #eee
    appearance: none
    background: url(../../public/icons/select-arrow-grad.png) 100% -6px no-repeat #fff

    option 
      white-space: nowrap

    &::-ms-expand
      /*pour cacher le bouton par défaut de ie*/
      display: none

    @supports (-moz-appearance:none)
      min-height: 0
      line-height: 2.0em

    &:disabled
      background-position: 100% -46px
      
    @media (max-width: 680px) 
      display: none

  .no-dropdown
    width: inherit
    max-width: 400px
    margin-right: 20px

.current
    box-shadow: -1px 2px 5px 0px rgba(0, 0, 0,0.5)
    opacity: 1 !important
    &:hover, &:focus
      text-decoration: none !important
      background: linear-gradient(to bottom,  $darkgray-2 0%, $darkgray-1 100%)

</style>
